import { ProductVariant } from '../../../../../../../types/api/products/Product';
import { useSelectedQuantityContext } from '../../../../TreatmentSelectorContext';

export interface OutOfStockBlocker {
    type: 'OUT_OF_STOCK';
}

/**
 * Returns the out of stock blocker.
 */
const getOutOfStockBlocker = (variant: ProductVariant, quantity: ReturnType<typeof useSelectedQuantityContext>) => {
    // If a variant has stock and the desired quantity is less than ore equal to the variant stock.
    if (variant.stock > 0 && quantity && quantity.quantity <= variant.stock) {
        return null;
    }

    return {
        type: 'OUT_OF_STOCK',
    };
};

export default getOutOfStockBlocker;
